import { IOptionItem } from "@/components/ui/dropdown/types";

import { ECategoryTransform } from "./types";

export const METHOD_OPTIONS = [
  { label: "Pivot", value: "PIVOT" },
  { label: "Transpose", value: "TRANSPOSE" }
];

export const SORT_OPTIONS = [
  { label: "Ascending (A to Z)", value: "ASC" },
  { label: "Descending (Z to A)", value: "DESC" }
];

export const AGGREGATION_CALCULATION_OPTIONS = [
  { label: "SUM", value: "SUM" },
  { label: "COUNT", value: "COUNT" },
  { label: "AVG", value: "AVG" },
  { label: "MIN", value: "MIN" },
  { label: "MAX", value: "MAX" }
];

export const AGGREGATION_CALCULATION_PIVOT_OPTIONS = [
  { label: "COUNT", value: "COUNT" }
];

export const CATEGORY_OPTIONS = [
  {
    label: "Display Row (Series)",
    value: ECategoryTransform.DISPLAY_ROWS_SERIES as string
  },
  {
    label: "Display Row (Agg)",
    value: ECategoryTransform.DISPLAY_ROWS_AGG as string
  }
];

export const SORT_BY_OPTIONS: IOptionItem[] = [
  { label: "Agg (Count)", value: "Agg(Count)" },
  { label: "Agg (Sum)", value: "Agg(Sum)" },
  { label: "Agg (Avg)", value: "Agg(Avg)" },
  { label: "Agg (Min)", value: "Agg(Min)" },
  { label: "Agg (Max)", value: "Agg(Max)" }
];

export const SORT_BY_PIVOT_OPTIONS: IOptionItem[] = [
  { label: "Agg (Count)", value: "Agg(Count)" }
];
